import { useEffect, useState } from 'react'
import MonitorParameterCurrentPanel from './current'
import MonitorParameterHistoryPanel from './history'
import MonitorObjectInfoPanel from './info'
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object'
import { getMonitorObjectById } from '@/api/monitor-object/monitor-object'
import { Transfer2DisplayScale } from '@/global/utils/unit-type'
import { emitter } from '@/global/listeners'
import { Emit_Event } from '@/enums/emit-event'

interface Iprops {
    monitorObjectId?: number
}

/**
 * 大屏端，监测对象信息面板
 */
export default function MonitorObjectRightMainPanel(props: Iprops) {
    const [item, setItem] = useState<MonitorObject>(); // 监测对象

    useEffect(() => {
        generateData();
    }, [props.monitorObjectId])

    // 查询监测对象详情
    const generateData = () => {
        if (!props.monitorObjectId) return;
        getMonitorObjectById(props.monitorObjectId).then(res => {
            let midItem: MonitorObject = res.data;
            setItem({ ...midItem });
        })
    }

    useEffect(() => {
        emitter.on(Emit_Event.LINE_CHART_UPDATE, generateData)
        return (() => {
            emitter.off(Emit_Event.LINE_CHART_UPDATE, generateData)
        })
    }, [props.monitorObjectId, item])

    return (
        <>
            <div className="device-code-area"><span className="device-code">{item?.name || ''}</span></div>
            <div className="panel-item">
                <MonitorParameterCurrentPanel monitorParameters={item?.rootMonitorParameters || []} />
            </div>
            <div className="panel-item">
                <MonitorParameterHistoryPanel monitorParameters={item?.rootMonitorParameters || []} />
            </div>
            <div className="panel-item">
                <MonitorObjectInfoPanel monitorObject={item} />
            </div>
        </>
    )
}